function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ); 
} 

class SectionId {
  static #separator = "__";

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }     
}      
   
class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = []
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
} 

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  if ($(summary).parent().hasClass("mega-menu") == false) {
    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });
  } else {
    $(summary).mouseenter(function () {
      $("details").removeAttr("open");
      $("summary").attr("aria-expanded", false);
      $(summary).attr("aria-expanded", true);
      $(summary).parents("details").attr("open", true);
    });

    $("details.mega-menu").mouseleave(function () {
      $(summary).parents("details").removeAttr("open");
      $(summary).attr("aria-expanded", false);
    });
  }

  if (summary.closest("header-drawer, menu-drawer")) return;
  if ($(summary).parent().hasClass("mega-menu") == false) {
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
} 

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}                    

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
  }
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }  

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === "") {
        const productUrl = this.dataset.url.split("?")[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const sourceQty = html.querySelector(
              ".quick-order-list-container"
            ).parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(
        `#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`
      )
    );
  }
}

customElements.define("bulk-modal", BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute("selected"))
        .removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest(".product-form__input")
        .querySelector("[data-selected-value] > .swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset"
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target
        .closest(`.product-form__input`)
        .querySelector("[data-selected-value]");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked")
    ).map(({ dataset }) => dataset.optionValueId);
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");
  }

  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this)
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define("account-icon", AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter(
      (queueElement) => !queue.includes(queueElement)
    );
    const quickBulkElement =
      this.closest("quick-order-list") || this.closest("quick-add-bulk");
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.min_error.replace(
          "[min]",
          event.target.dataset.min
        )
      );
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.max_error.replace(
          "[max]",
          event.target.max
        )
      );
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.step_error.replace(
          "[step]",
          event.target.step
        )
      );
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

if (!customElements.get("bulk-add")) {
  customElements.define("bulk-add", BulkAdd);
}

// scopeEl (optional) restricts the .gift-box lookup to a single form/popup
// instance instead of the whole document. Without it, a product whose
// .gift-box appears more than once in the DOM at once — e.g. its own
// product-page buy box AND a collection-grid quick-view popup for the same
// product open at the same time, or two "recommended products" widgets both
// featuring it — silently grabs whichever instance happens to be first in
// DOM order, not the one the customer actually interacted with. That other
// instance is typically still at its default (nothing unlocked) state, so
// the add-to-cart that follows carries an empty/wrong gift roster even
// though the customer's own popup clearly showed gifts unlocked.
function getGiftBoxRoster(parentProductId, scopeEl) {
  if (!parentProductId) return null;
  var root = scopeEl || document;
  var giftBox = root.querySelector(
    '.gift-box[data-parent-product-id="' + parentProductId + '"]'
  );
  if (!giftBox) return null;

  // Each grid slot only ever carries a data-variant-id when it's currently
  // filled with a real product from the SELECTED parent variant's own
  // gift_products list (buy-box-gift-list.js clears it for placeholder
  // slots), so every matching element here already IS that variant's own
  // gift set — no separate variant->gift map lookup needed.
  var variantIds = [];
  giftBox.querySelectorAll(".gift-box__item[data-variant-id]").forEach(function (item) {
    var variantId = item.getAttribute("data-variant-id");
    if (variantId) variantIds.push(variantId);
  });

  if (variantIds.length === 0) return null;

  return {
    variantIds: variantIds,
    activeVariantIds: variantIds,
    unlockAllOnetime: giftBox.getAttribute("data-unlock-all-onetime") === "true",
  };
}

function generateGiftLineToken(parentProductId) {
  return (
    parentProductId +
    "-" +
    Date.now() +
    "-" +
    Math.random().toString(36).slice(2, 8)
  );
}

// scopeEl: see getGiftBoxRoster above — same reason this can't be an
// unscoped document.querySelector.
function collectGiftBoxItems(parentProductId, lineToken, scopeEl) {
  var items = [];
  if (!parentProductId || !lineToken) return items;
  var root = scopeEl || document;
  var giftBox = root.querySelector(
    '.gift-box[data-parent-product-id="' + parentProductId + '"]'
  );
  if (!giftBox) return items;

  giftBox.querySelectorAll(".gift-box__item.is-unlocked").forEach(function (giftItem) {
    var variantId = giftItem.getAttribute("data-variant-id");
    if (!variantId) return;
    items.push({
      id: variantId,
      quantity: 1,
      properties: {
        _GiftBoxItem: true,
        _GiftBoxParent: lineToken,
      },
    });
  });

  return items;
}

// scopeEl: see getGiftBoxRoster above.
function addGiftBoxItemsAfterMainAdd(parentProductId, lineToken, onComplete, scopeEl) {
  var giftItems = collectGiftBoxItems(parentProductId, lineToken, scopeEl);
  if (giftItems.length === 0) {
    if (onComplete) onComplete();
    return;
  }

  fetch(routes.cart_add_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ items: giftItems }),
  })
    .then((response) => response.json())
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      if (onComplete) onComplete();
    });
}

class MainProductForm extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");
  }

  connectedCallback() {
    // Collection grids render one hidden quick-view popup (its own
    // <main-product-form>) per product card, so connectedCallback fires once
    // per card on that page. A direct (non-delegated) $(".variants-query")
    // binding here re-bound a fresh click handler to EVERY "Why most choose
    // to subscribe?" icon on the page on every single card's connect — with
    // N cards, each icon ended up with N stacked handlers, so one click
    // called .toggle() N times and (for even N) canceled itself out,
    // silently opening nothing. A single document-level delegated binding,
    // guarded to run once no matter how many forms connect, fixes both the
    // PDP (one form) and collection quick-view (many forms) cases the same
    // way.
    if (!window.variantsQueryPopupBound) {
      window.variantsQueryPopupBound = true;
      $(document).on("click", ".variants-query", function (event) {
        event.stopPropagation();
        $(this).find(".variants-query-popup-wrapper").toggle();
      });
      $(document).on("click", function (event) {
        if (!$(event.target).closest(".variants-query").length) {
          $(".variants-query-popup-wrapper").hide();
        }
      });
    }

    var prjson = $(this).find(".productjson").html();

    var symbol = $("body").data("currency");
    // console.log(prjson)

    var this2 = this;
    var defaultpack = $(this2).find(".variant-item").eq(0).data("packsize");

    function atcPriceHtml(price, compareAtPrice) {
      var priceHtml = Shopify.formatMoney(price, symbol + "{{amount}}");
      if (compareAtPrice && compareAtPrice > price) {
        var compareHtml = Shopify.formatMoney(
          compareAtPrice,
          symbol + "{{amount}}"
        );
        return `Add To Cart - ${priceHtml} <del class="atc-compare-price">${compareHtml}</del>`;
      }
      return `Add To Cart - ${priceHtml}`;
    }
    $(this)
      .find(".rc-radio__input")
      .change(function () {
        if (
          $(this2).find(".rc-radio__input:checked").attr("value") ==
          "subscription"
        ) {
          // Scoped to this buy box: the collection grid renders one quick-view
          // popup per product card, so an unscoped selector would toggle every
          // other product's badge from whichever popup was interacted with.
          $(this2).find(".variant-main-badge").show();
        } else {
          $(this2).find(".variant-main-badge").hide();
        }
        initPricing();
      });
    initPricing();
    document.addEventListener("initSubscriptionPricing", () => {
      initPricing();
    });
    function updatePurchaseOptionPrices() {
      var checkedVariantEl = $(this2).find(".variant-item:checked");
      if (checkedVariantEl.length === 0 || !prjson) return;

      var packsize = parseInt(checkedVariantEl.data("packsize"), 10) || 1;
      var variantId = checkedVariantEl.val();
      var varjson = null;
      for (var i = 0; i < prjson.length; i++) {
        if (prjson[i].id == variantId) {
          varjson = prjson[i];
          break;
        }
      }
      if (!varjson) return;

      var onetimePerBag = varjson.price / packsize;
      $(this2)
        .find(".onetimeprice")
        .html(Shopify.formatMoney(onetimePerBag, symbol + "{{amount}}"));

      if (
        varjson.selling_plan_allocations &&
        varjson.selling_plan_allocations.length > 0
      ) {
        var subPerBag = varjson.selling_plan_allocations[0].price / packsize;
        $(this2)
          .find(".subscriptionprice")
          .html(Shopify.formatMoney(subPerBag, symbol + "{{amount}}"));
      }
    }

    function initPricing() {
      var hasdiscount = $(this2).find(".productjson").attr("data-hasdiscount");
      var hassubscription = $(this2)
        .find(".productjson")
        .attr("data-subscription");
      var hasonetime = $(this2).find(".productjson").attr("data-onetime");
      var discountype = $(this2).find(".productjson").attr("data-discounttype");
      var discount = Number(
        $(this2).find(".productjson").attr("data-discountvalue")
      );
       
      prjson = JSON.parse($(this2).find(".productjson").html());
      hasdiscount = $(this2).find(".productjson").attr("data-hasdiscount");
      discount = Number(
        $(this2).find(".productjson").attr("data-discountvalue")
      );
      //console.log(discount + '  ddd')
      var checkedvar = $(this2).find(".variant-item:checked").val();
      if (
        $(this2).find(".rc-radio__input:checked").attr("value") ==
        "subscription"
      ) {
         
        $(this2).find(".variant-wrapper").removeClass("onetime");
        $(this2).find(".variant-wrapper").addClass("subscription");
        $(this2)
          .find(".variant-item-wrapper")
          .each(function () {
            for (let index = 0; index < prjson.length; index++) {
              var varjson = prjson[index];
              if (varjson.id == $(this).find(".variant-item").val()) {
                var sellingplan = varjson.selling_plan_allocations[0];
                var planname = "Delivery every 4 week";

                for (
                  let j = 0;
                  j < varjson.selling_plan_allocations.length;
                  j++
                ) {
                  if (
                    varjson.selling_plan_allocations[j].selling_plan_id ==
                    $(this).find(".variant-item").data("sellingplan")
                  ) {
                    sellingplan = varjson.selling_plan_allocations[j];
                  }
                }
                var packsize = $(this).find(".variant-item").data("packsize");
                var quantity = packsize / defaultpack;
                // The variant's own compare_at_price, not the selling plan
                // allocation's — Recharge sets the allocation's own
                // compare_at_price to the plain one-time price, which isn't
                // the strikethrough value the merchant sets for Subscribe &
                // Save; that lives directly on the variant.
                var compareprice = varjson.compare_at_price;
                // Declared here (not just inside the discount branch below)
                // so a variant with no compare_at_price set yet still gets a
                // real price instead of showing "£0" from an undefined var.
                var price = sellingplan.price;
                // 1 Bag/Bottle is the one exception: its strikethrough
                // always comes from THIS variant's own one-time price
                // versus its Subscribe & Save price, full stop — never from
                // compare_at_price. Mirrors subscription-buy-box.liquid's
                // server-rendered default state above.
                if (Number(packsize) === 1) {
                  compareprice = varjson.price;
                }
                if (compareprice > sellingplan.price) {
                  if (hasdiscount == "true" && hassubscription == "true") {
                    $(this2).find(".first-order").show();
                    if (discountype == "percent") {
                      var discountam = (price * discount) / 100;
                      price = price - discountam;
                    } else if (discountype == "amount") {
                      price = price - discount * 100;
                    }
                  }
                  var save = compareprice - price;
                  var saveper = (save * 100) / compareprice;
                  $(this)
                    .find(".variant-subs-price")
                    .html(
                      `<del>${Shopify.formatMoney(
                        compareprice,
                        symbol + "{{amount}}"
                      )}</del><span class="money">${Shopify.formatMoney(
                        price,
                        symbol + "{{amount}}"
                      )}</span>`
                    );
                  $(this).find(".variant-subs-discount").show();
                  $(this)
                    .find(".variant-subs-discount")
                    .html(`Save ${Math.round(saveper)}%`);
                } else {
                  $(this)
                    .find(".variant-subs-price")
                    .html(
                      `${Shopify.formatMoney(price, symbol + "{{amount}}")}`
                    );
                  $(this).find(".variant-subs-discount").hide();
                }
                $(this)
                  .find(".variant-points-badge")
                  .html(`+${Math.trunc(price / 100)} Smart Points`);
                $(this)
                  .find(".variant-subs-month")
                  .html(
                    `${Shopify.formatMoney(
                      price / quantity,
                      symbol + "{{amount}}"
                    )}/Mo`
                  );
                if (checkedvar == $(this).find(".variant-item").val()) {
                  if (varjson.available == true) {
                    $(this2)
                      .find(".add-to-cart-btn .atc-text")
                      .html(atcPriceHtml(price, compareprice));
                    $(this2).find(".add-to-cart-btn").removeClass(`disabled`);
                  } else {
                    $(this2).find(".add-to-cart-btn .atc-text").html(`Sold Out`);
                    $(this2).find(".add-to-cart-btn").addClass(`disabled`);
                  }
                }
              }
            }
          });
      } else {
        $(this2).find(".variant-wrapper").addClass("onetime");
        $(this2).find(".variant-wrapper").removeClass("subscription");
        $(this2).find(".first-order").hide();
        $(this2)
          .find(".variant-item-wrapper")
          .each(function () {
            for (let index = 0; index < prjson.length; index++) {
              var varjson = prjson[index];
              if (varjson.id == $(this).find(".variant-item").val()) {
                var quantity =
                  $(this).find(".variant-item").data("packsize") / defaultpack;
                var compareprice = varjson.compare_at_price;
                var price = varjson.price;
                if (hasdiscount == "true" && hasonetime == "true") {
                  if (discountype == "percent") {
                    var discountam = (price * discount) / 100;
                    price = price - discountam;
                  } else if (discountype == "amount") {
                    price = price - discount * 100;
                  }
                }
                if (compareprice > price) {
                  var save = compareprice - price;
                  var saveper = (save * 100) / compareprice;
                  $(this)
                    .find(".variant-subs-price")
                    .html(
                      `<del>${Shopify.formatMoney(
                        compareprice,
                        symbol + "{{amount}}"
                      )}</del><span class="money">${Shopify.formatMoney(
                        price,
                        symbol + "{{amount}}"
                      )}</span>`
                    );
                  $(this).find(".variant-subs-discount").show();
                  $(this)
                    .find(".variant-subs-discount")
                    .html(`Save ${Math.round(saveper)}%`);
                } else {
                  $(this)
                    .find(".variant-subs-price")
                    .html(
                      `${Shopify.formatMoney(price, symbol + "{{amount}}")}`
                    );
                  $(this).find(".variant-subs-discount").hide();
                }
                $(this)
                  .find(".variant-points-badge")
                  .html(`+${Math.trunc(price / 100)} Smart Points`);
                $(this)
                  .find(".variant-subs-month")
                  .html(
                    `${Shopify.formatMoney(
                      price / quantity,
                      symbol + "{{amount}}"
                    )}/Mo`
                  );
                if (checkedvar == $(this).find(".variant-item").val()) {
                  if (varjson.available == true) {
                    $(this2)
                      .find(".add-to-cart-btn .atc-text")
                      .html(atcPriceHtml(price, compareprice));
                    $(this2).find(".add-to-cart-btn").removeClass(`disabled`);
                  } else {
                    $(this2).find(".add-to-cart-btn .atc-text").html(`Sold Out`);
                    $(this2).find(".add-to-cart-btn").addClass(`disabled`);
                  }
                }
              }
            }
          });
      }

      updatePurchaseOptionPrices();
    }

    $(this2)
      .find(".variant-item")
      .click(function () {
        var hasdiscount = $(this2)
          .find(".productjson")
          .attr("data-hasdiscount");
        var hassubscription = $(this2)
          .find(".productjson")
          .attr("data-subscription");
        var hasonetime = $(this2).find(".productjson").attr("data-onetime");
        var discountype = $(this2)
          .find(".productjson")
          .attr("data-discounttype");
        var  discount = Number(
            $(this2).find(".productjson").attr("data-discountvalue")
          );  
        if (
          $(this2).find(".rc-radio__input:checked").attr("value") ==
          "subscription"
        ) {
          var varjson = null;
          var sellingplan = null;
          for (let index = 0; index < prjson.length; index++) {
            if (prjson[index].id == $(this).val()) {
              varjson = prjson[index];
              sellingplan = varjson.selling_plan_allocations[0];
              for (
                let j = 0;
                j < varjson.selling_plan_allocations.length;
                j++
              ) {
                if (
                  varjson.selling_plan_allocations[j].selling_plan_id ==
                  $(this).data("sellingplan")
                ) {
                  sellingplan = varjson.selling_plan_allocations[j];
                }
              }
              break;
            }
          }
          if (!varjson) return;

          var packsize = $(this).data("packsize");
          var quantity = packsize / defaultpack;
          // The variant's own compare_at_price, not the selling plan
          // allocation's — see matching comment above for why.
          var compareprice = varjson.compare_at_price;
          var price = sellingplan.price;
          // Same 1 Bag/Bottle rule as initPricing() above — this is a
          // SEPARATE click handler (fires when clicking a quantity card,
          // via buy-box-variant-picker.js's syncHiddenVariant() clicking
          // this hidden .variant-item radio) that rebuilds the Add To Cart
          // button text independently of initPricing(). Without this here
          // too, switching quantity cards away from and back to 1 Bag/Bottle
          // dropped the rule initPricing() had applied on page load, and
          // the strikethrough reverted to whatever compare_at_price holds.
          if (Number(packsize) === 1) {
            compareprice = varjson.price;
          }

          if (hasdiscount == "true" && hassubscription == "true") {
            if (discountype == "percent") {
              var discountam = (price * discount) / 100;
              price = price - discountam;
            } else if (discountype == "amount") {
              price = price - discount * 100;
            }
          }

          if (varjson.available == true) {
            $(this2)
              .find(".add-to-cart-btn .atc-text")
                      .html(atcPriceHtml(price, compareprice));
            $(this2).find(".add-to-cart-btn").removeClass(`disabled`);
          } else {
            $(this2).find(".add-to-cart-btn .atc-text").html(`Sold Out`);
            $(this2).find(".add-to-cart-btn").addClass(`disabled`);
          }
        } else {
          for (let index = 0; index < prjson.length; index++) {
            var varjson = prjson[index];
            if (varjson.id == $(this).val()) {
              var price = varjson.price;
              var quantity = $(this).data("packsize") / defaultpack;
              var compareprice = varjson.compare_at_price;

              if (hasdiscount == "true" && hasonetime == "true") {
                if (discountype == "percent") {
                  var discountam = (price * discount) / 100;
                  price = price - discountam;
                } else if (discountype == "amount") {
                  price = price - discount * 100;
                }
              }
              if (varjson.available == true) {
                $(this2)
                  .find(".add-to-cart-btn .atc-text")
                      .html(atcPriceHtml(price, compareprice));
                $(this2).find(".add-to-cart-btn").removeClass(`disabled`);
              } else {
                $(this2).find(".add-to-cart-btn .atc-text").html(`Sold Out`);
                $(this2).find(".add-to-cart-btn").addClass(`disabled`);
              }
            }
          }
        }

        updatePurchaseOptionPrices();
      });

    $(this2)
      .find(".add-to-cart-btn")
      .click(function () {
        this2.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        console.log(this.cart);
        $(this).find(".loading__spinner").removeClass("hidden");
        $(this).find(".atc-text").css("opacity", "0");
        $(this).find(".atc-guarantee").css("opacity", "0");
        $(".erro-mesg").remove();
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData();
        if (this2.cart) {
          formData.append(
            "sections",
            this2.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this2.cart.setActiveElement(document.activeElement);
        }

        formData.append("id", $(this2).find(".variant-item:checked").val());
        formData.append("quantity", 1);

        if ($(this2).find(".rc-radio__input:checked").val() == "subscription") {
          formData.append(
            "selling_plan",
            $(this2).find(".variant-item:checked").data("sellingplan")
          );
        }

        var giftBoxRoster = getGiftBoxRoster(this2.dataset.pid, this2);
        var giftLineToken = null;
        if (giftBoxRoster) {
          giftLineToken = generateGiftLineToken(this2.dataset.pid);
          formData.append("properties[_GiftBoxLineToken]", giftLineToken);
          formData.append(
            "properties[_GiftBoxRoster]",
            giftBoxRoster.variantIds.join(",")
          );
          formData.append(
            "properties[_GiftBoxActiveIds]",
            giftBoxRoster.activeVariantIds.join(",")
          );
          formData.append(
            "properties[_GiftBoxUnlockAllOnetime]",
            giftBoxRoster.unlockAllOnetime ? "true" : "false"
          );
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            $(this2).find(".loading__spinner").addClass("hidden");
            $(this2).find(".atc-text").css("opacity", "1");
            $(this2).find(".atc-guarantee").css("opacity", "1");
            if (response.status) {
              $(this2)
                .find(".add-to-cart-btn")
                .after(
                  '<div class="erro-mesg" style="color:red;margin-top:10px;">' +
                    response.description +
                    "</div>"
                );
              return;
            } else if (!this2.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this2.cart.renderContents(response);

            $("cart-drawer").removeClass("is-empty");
            document.dispatchEvent(new Event("initCartFunctions"));

            addGiftBoxItemsAfterMainAdd(this2.dataset.pid, giftLineToken, function () {
              reloadDrawer();
            }, this2);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {});
      });

    $(this)
      .find(".checkout-btn")
      .click(function () {
        this2.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        console.log(this.cart);
        $(this).find(".loading__spinner").removeClass("hidden");
        $(this).find(".atc-text").css("opacity", "0");
        $(this).find(".atc-guarantee").css("opacity", "0");
        $(".erro-mesg").remove();
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData();
        formData.append("id", $(this2).find(".variant-item:checked").val());
        formData.append("quantity", 1);

        if ($(this2).find(".rc-radio__input:checked").val() == "subscription") {
          formData.append(
            "selling_plan",
            $(this2).find(".variant-item:checked").data("sellingplan")
          );
        }

        var giftBoxRoster = getGiftBoxRoster(this2.dataset.pid, this2);
        var giftLineToken = null;
        if (giftBoxRoster) {
          giftLineToken = generateGiftLineToken(this2.dataset.pid);
          formData.append("properties[_GiftBoxLineToken]", giftLineToken);
          formData.append(
            "properties[_GiftBoxRoster]",
            giftBoxRoster.variantIds.join(",")
          );
          formData.append(
            "properties[_GiftBoxActiveIds]",
            giftBoxRoster.activeVariantIds.join(",")
          );
          formData.append(
            "properties[_GiftBoxUnlockAllOnetime]",
            giftBoxRoster.unlockAllOnetime ? "true" : "false"
          );
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            $(this2).find(".loading__spinner").addClass("hidden");
            $(this2).find(".atc-text").css("opacity", "1");
            $(this2).find(".atc-guarantee").css("opacity", "1");
            addGiftBoxItemsAfterMainAdd(this2.dataset.pid, giftLineToken, function () {
              window.location.href = "/checkout";
            }, this2);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {});
      });
  }
}

customElements.define("main-product-form", MainProductForm);

// reloadDrawer()/reloadCartIconBubble() were ALSO separately declared as
// plain top-level `function`s in cart-drawer.js (and, until just now, a
// third time in cart.js) — three files, same two global names, each
// silently overwriting the last as deferred scripts execute in document
// order. cart-drawer.js loads last (it's conditional on settings.cart_type
// == 'drawer', rendered near the end of theme.liquid), so its copy — the
// only one of the three that actually `return`s its fetch promise, which
// its own many `reloadDrawer().then(endCheckoutBusy)` callers require — is
// the one that currently wins in practice. That's fragile by accident, not
// by design: any future script-order change silently breaks every one of
// those callers with no error pointing at why.
//
// Defined here as a real fallback instead: only takes effect if nothing has
// claimed window.reloadDrawer yet (true the moment THIS script runs, since
// cart-drawer.js hasn't loaded yet regardless of whether it's on this page
// at all — script order alone can't be relied on to prevent the collision).
// When cart-drawer.js's own copy loads moments later it unconditionally
// overwrites this — same net behavior as today when the drawer is enabled.
// When it ISN'T on the page (settings.cart_type != 'drawer'), THIS is what
// keeps this file's own reloadDrawer() call (in MainProductForm's add-to-cart
// handler above) from throwing ReferenceError instead of silently doing
// nothing.
if (typeof window.reloadDrawer !== "function") {
  window.reloadDrawer = function reloadDrawer() {
    var mainSwap = fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const selectors = [
          "cart-drawer-items",
          ".cart-drawer__footer",
          ".drawer__inner",
        ];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
        document.dispatchEvent(new Event("initCartFunctions"));
      })
      .catch((e) => {
        console.error(e);
        document.dispatchEvent(new Event("initCartFunctions"));
      });
    reloadCartIconBubble();
    return mainSwap;
  };
}
if (typeof window.reloadCartIconBubble !== "function") {
  window.reloadCartIconBubble = function reloadCartIconBubble() {
    fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((responseText) => {
        const cartIconBubble = document.getElementById("cart-icon-bubble");
        if (!cartIconBubble) return;
        const source = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector(".shopify-section");
        if (source) cartIconBubble.innerHTML = source.innerHTML;
      })
      .catch((e) => console.error(e));
  };
}

jQuery(document).ready(function ($) {
  if (window.location.href.indexOf("?viewcart=1") >= 0) {
    var cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    cart.open();
  }
});

class FaqSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".faq-questions-" + this.getAttribute("data-sectionid")).click(
        function (e) {
          e.preventDefault();
          let $this = $(this);
          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);
            $this.parent().removeClass("active");
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });
          } else {
            $(".faq-accordion-wrapper")
              .find(".faq-answers")
              .removeClass("show");
            $(".faq-accordion-wrapper").find(".faq-answers").slideUp(350);
            $(".faq-accordion-wrapper").removeClass("active");
            $(".faq-accordion-wrapper")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $(".faq-accordion-wrapper")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });
            $this.next().toggleClass("show");
            $this.next().slideToggle(350);
            $this.parent().toggleClass("active");
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "none" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "flex" });
          }
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("faq-section", FaqSection);

class FaqImageText extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(
        ".faq-with-image-questions-" + this.getAttribute("data-sectionid")
      ).click(function (e) {
        e.preventDefault();
        let $this = $(this);
        if ($this.next().hasClass("show")) {
          $this.next().removeClass("show");
          $this.next().slideUp(350);
          $this.parent().removeClass("active");
          $this
            .find(".fa-chevron-arrows")
            .find(".fa-with-image-chevron-down")
            .css({ display: "flex" });
        } else {
          $(".faq-image-with-accordion-wrapper")
            .find(".faq-with-image-answers")
            .removeClass("show");
          $(".faq-image-with-accordion-wrapper")
            .find(".faq-with-image-answers")
            .slideUp(350);
          $(".faq-image-with-accordion-wrapper").removeClass("active");
          $(".faq-image-with-accordion-wrapper")
            .find(".fa-chevron-arrows")
            .find(".fa-with-image-chevron-down")
            .css({ display: "flex" });

          $this.next().toggleClass("show");
          $this.next().slideToggle(350);
          $this.parent().toggleClass("active");
          $this
            .find(".fa-chevron-arrows")
            .find(".fa-with-image-chevron-up")
            .css({ display: "flex" });
        }
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("faq-with-image", FaqImageText);

class CategorySliderArticle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      $(this).css({ opacity: "1" });
      var filtercustom = new Swiper(
        ".articles-lower-section--" + this.getAttribute("data-sectionid"),
        {
          spaceBetween: 1.2,
          slidesPerView: 23,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            0: {
              slidesPerView: 1.2,
              spaceBetween: 23,
            },
            660: {
              slidesPerView: 2,
              spaceBetween: 23,
            },
            990: {
              slidesPerView: 2.4,
              spaceBetween: 23,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 23,
            },
          },
        }
      );
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("category-slider-article", CategorySliderArticle);

document.addEventListener("applyDiscountCode", (e) => {
  console.log(e.detail.code);
  initDiscount(e.detail.code);
});

function initDiscount(code) {
  var ccode = code.toLowerCase();

  var settings = {
    url: "https://devwebhooks.com/prettysmartfood/getdiscounts.php",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: {
      code: code,
    },
  };

  $.ajax(settings).done(function (response) {
    if (response.status == 200) {
      var resp = response.response;
      if (resp.data.codeDiscountNodeByCode.codeDiscount.status == "ACTIVE") {
        var hidepack = false;
        if (
          $(".hidepackdiscounts").find(
            '.discount-item[data-discountcode="' + ccode + '"]'
          ).length > 0
        ) {
          hidepack = true;
        }
        applyCode(response.response, hidepack);
      } else {
        console.log("discount expired");
      }
    } else {
      console.log("discount not valid");
    }
  });
}                    
        
function applyCode(rawResponse, hidepack) {
  console.log("applyCode hidepack:", hidepack);

  // Depending on how you call this you might have {status, response: {...}}
  const response = rawResponse.data ? rawResponse : rawResponse.response || rawResponse;

  const node = response.data?.codeDiscountNodeByCode;
  const codeDiscount = node?.codeDiscount;
  if (!codeDiscount) {
    console.warn("No codeDiscount in response");
    return;
  }

  const discountClass = codeDiscount.discountClass; // "ORDER" | "PRODUCT" | "SHIPPING"
  // We only care about discounts that affect line items
  if (discountClass !== "ORDER" && discountClass !== "PRODUCT") {
    console.log("Skipping discountClass:", discountClass);
    return;
  }

  const customerGets = codeDiscount.customerGets;
  const itemsNode   = customerGets.items;
  const valueNode   = customerGets.value;

  const suballowed  = customerGets.appliesOnSubscription;
  const onetallowed = customerGets.appliesOnOneTimePurchase;

  let value = 0;
  let discountTypeAttr = ""; // "percent" | "amount"

  if (valueNode.__typename === "DiscountPercentage") {
    value = parseInt(valueNode.percentage * 100, 10); // 0.1 -> 10
    discountTypeAttr = "percent";
  } else if (valueNode.__typename === "DiscountAmount") {
    value = valueNode.amount.amount * Shopify.currency.rate; // in shop money units
    discountTypeAttr = "amount";
  } else {
    console.warn("Unsupported value type:", valueNode.__typename);
    return;
  }

  // Helper: mark a specific main-product-form as having this discount
  function markProductForm($form) {
    if (!$form.length) return;

    $form.find(".productjson")
      .attr("data-hasdiscount", "true")
      .attr("data-discounttype", discountTypeAttr)
      .attr("data-discountvalue", value)
      .attr("data-subscription", suballowed)
      .attr("data-onetime", onetallowed);

    $form.find(".first-order").show();

    if (hidepack === true) {
      $form.find('.variant-item[data-packsize="3"]')
           .parents(".variant-item-wrapper")
           .hide();
    }
  }

  // ==== APPLY TO ALL / SPECIFIC PRODUCTS ====

  if (itemsNode.__typename === "AllDiscountItems") {
    // ORDER level discount for all items OR product discount on all items
    $("main-product-form[data-pid]").each(function () {
      markProductForm($(this));
    });
  } else if (itemsNode.__typename === "DiscountProducts") {
    // Selected variants
    const discountVariants = itemsNode.productVariants?.nodes || [];
    discountVariants.forEach(node => {
      const prid = node.product.id.replace("gid://shopify/Product/", "");
      markProductForm($('main-product-form[data-pid="' + prid + '"]'));
    });

    // Selected products
    const discountProducts = itemsNode.products?.nodes || [];
    discountProducts.forEach(node => {
      const prid = node.id.replace("gid://shopify/Product/", "");
      markProductForm($('main-product-form[data-pid="' + prid + '"]'));
    });
  } else {
    console.warn("Unsupported items type:", itemsNode.__typename);
  }

  // ==== HEADER BANNER ====
  // Show banner if we're on a product page or discount applies to all items
  if ($("body").data("template") === "product" || itemsNode.__typename === "AllDiscountItems") {
    $(".discount-announcement-slider .swiper-slide.discounted").show();
    $(".discount-announcement-slider .seperator-holder").show();
    $(".discount-announcement-slider .swiper-slide.non-discounted").hide();

    if (discountTypeAttr === "percent") {
      $(".discount-announcement-slider .discount-slide").html(
        value + "% OFF applied"
      );
    } else if (discountTypeAttr === "amount") {
      $(".discount-announcement-slider .discount-slide").html(
        Shopify.formatMoney(value * 100, "{{amount_with_currency}}") +
          " OFF applied"
      );
    }
  }

  // Re-run your price calculation
  const startEvent = new Event("initSubscriptionPricing");
  document.dispatchEvent(startEvent);
}



var searchPrms = new URLSearchParams(window.location.search);

if (searchPrms.has("discount")) {
  var code = searchPrms.get("discount").toLowerCase();
  var applycode = new CustomEvent("applyDiscountCode", {
    detail: { code: code },
  });
  document.dispatchEvent(applycode);
}else{
  if($('#discount-coupon-text').val() != ''){
    var applycode = new CustomEvent("applyDiscountCode", {
      detail: { code: $('#discount-coupon-text').val() },
    });
    document.dispatchEvent(applycode);
  }
} 
 